/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/present.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns true if the input expression yields any non-null values within the current aggregation context. Otherwise it returns false.',
  examples: [
    'FROM employees\n| STATS is_present = PRESENT(languages)',
    'FROM employees\n| STATS is_present = PRESENT(salary) BY languages',
    'FROM employees\n| WHERE emp_no == 10020\n| STATS is_present = TO_INTEGER(PRESENT(languages))',
  ],
  params: {
    field: 'Expression that outputs values to be checked for presence.',
  },
};

export default docs;
